/**
 * Shared document UI metadata. Both the admin Edit Employee page
 * (apps/web/src/routes/employeeDetail.tsx — DocumentsSection) and
 * the employee self-service view (apps/web/src/routes/myDocuments.tsx)
 * import from here so the kind labels stay in lockstep.
 *
 * The values mirror the EmployeeDocumentKind enum in @kora/types;
 * the labels are user-facing English. If a label changes, change it
 * once here and both surfaces pick it up.
 */

import type { EmployeeDocumentKind } from '@kora/types';

export interface DocumentKindOption {
  value: EmployeeDocumentKind;
  label: string;
}

export const DOCUMENT_KIND_OPTIONS: DocumentKindOption[] = [
  { value: 'certificate', label: 'Certificate (degree, training, professional)' },
  { value: 'contract', label: 'Contract (employment, NDA, addendum)' },
  { value: 'job_description', label: 'Job description' },
  { value: 'id_document', label: 'ID document (passport, national ID)' },
  { value: 'performance_review', label: 'Performance review' },
  { value: 'other', label: 'Other' },
];

/**
 * Plural section heading for grouping a list of documents by kind.
 * The form-field labels above include qualifying parentheticals
 * ("Contract (employment, NDA, addendum)") which look right next to
 * an input but feel heavy as a section heading on a list view.
 */
export const DOCUMENT_KIND_PLURAL: Record<EmployeeDocumentKind, string> = {
  certificate: 'Certificates',
  contract: 'Contracts',
  job_description: 'Job description',
  id_document: 'ID documents',
  performance_review: 'Performance reviews',
  other: 'Other',
};
